/**
 * Product Size Selector
 * Handles navigation between linked products (size variants as separate products)
 */

class ProductSizeSelector {
  constructor() {
    this.selectors = document.querySelectorAll('.product-size-selector');
    this.init();
  }

  init() {
    this.selectors.forEach((selector) => {
      selector.addEventListener('change', this.handleSizeChange.bind(this));
    });
  }

  handleSizeChange(event) {
    const select = event.target;
    const selectedOption = select.options[select.selectedIndex];
    const productUrl = selectedOption.dataset.productUrl;
    const updateUrl = select.dataset.updateUrl === 'true';

    if (!productUrl) {
      console.error('ProductSizeSelector: No product URL found on selected option');
      return;
    }

    // Check if the product is available
    const isAvailable = selectedOption.dataset.available === 'true';

    // Navigate to the selected product
    // Use history.pushState if update_url is true, otherwise just navigate
    if (updateUrl) {
      // Update URL without page reload first, then fetch new content
      window.history.pushState({ path: productUrl }, '', productUrl);
    }

    // Navigate to the product page
    // Using window.location for full page reload to ensure all product data is fresh
    window.location.href = productUrl;
  }

  /**
   * Get product data from the JSON script tag
   */
  getProductData(sectionId) {
    const dataElement = document.querySelector(`[data-size-selector-products="${sectionId}"]`);
    if (dataElement) {
      try {
        return JSON.parse(dataElement.textContent);
      } catch (error) {
        console.error('ProductSizeSelector: Error parsing product data', error);
        return null;
      }
    }
    return null;
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ProductSizeSelector();
  });
} else {
  new ProductSizeSelector();
}

// Re-initialize after Shopify section renders (for theme editor)
document.addEventListener('shopify:section:load', () => {
  new ProductSizeSelector();
});
